<template>
	<div data-scrollbottom-notif @click="scrollBottom"></div>
	<stuck-header :header-text="currentHeaderText" :date="currentDate" :visible="stuckHeaderVisible" :header-class="currentHeaderClass"></stuck-header>
	<div class="vue-debug-container">
		<div class="debug-item" v-for="item in debugValues" :style="{ top: item.top + 'px' }">
			<span>{{ item.key }}</span>
		</div>
	</div>
	<tabs :mode="mode"></tabs>
	<div class="lists">
		<race-list v-ref:lists v-for="list in lists" :class="list.class" :id="list.id" :list="list" :empty-text="list.emptyText"></race-list>
	</div>
</template>

<script>
	import Tabs from './Tabs.vue'
	import RaceList from './RaceList.vue'
	import RaceLists from './../mock/RaceLists'
	import _ from 'underscore'
	import deepClone from 'object-assign-deep'
	import moment from 'moment'
	import StuckHeader from './StuckHeader.vue'
	export default {
		components: { Tabs, RaceList, StuckHeader },
		data() {
			return {
				mode: 'all',
				lists: [],
				lastMonth: moment().add(1, 'month').startOf('month'),
				listsLoading: 0,
				selectedMonth: 'none',
				supportAddingMonths: true,
				monthFails: 0,
				currentHeaderText: 'test',
				currentHeaderClass: '',
				currentDate: moment().startOf('day'),
				stuckHeaderVisible: false,
				internalDebugValues: {},
				debugValues: [],
				debug: false
			};
		},
		asyncData() {

			this.lists = [];
			this.removeStickies();

			if (this.selectedMonth != 'none') {
				this.lastMonth = moment().add(this.selectedMonth + 1, 'month').startOf('month');
			} else {
				this.lastMonth = moment().add(1, 'month').startOf('month');
				this.addLists(RaceLists);
			}

			this.loadAnotherMonth(true);

		},
		events: {
			'change-mode': function (e, mode) {
				this.mode = mode;
				this.supportAddingMonths = true;
			},
			'change-month': function (month) {
				this.selectedMonth = month;
				this.supportAddingMonths = true;
			},
			'list-loaded': function () {
				this.listsLoading--;
				if (this.listsLoading < 0) {
					this.listsLoading = 0;
				}
			},
			'update-debug-value': function (key, value) {
				this.updateDebugValue(key, value);
			}
		},
		methods: {
			updateDebugValue: function (key, value) {
				if (!this.debug) return;
				this.internalDebugValues[key] = value;
				var self = this;
				self.debugValues = [];
				_.each(this.internalDebugValues, function (item, key) {
					self.debugValues.push({
						top: item,
						key: key
					});
				});
			},
			removeStickies: function () {
				if (typeof(window.ABR.Sticky) !== 'undefined') {
					window.ABR.Sticky.remove('.race-schedule-header');
				}
			},
			scroll: function () {

				var self = this;
				var offset = window.pageYOffset;
				offset += window.ABR.Sticky.offsetHeight - 10;
				var activeList = false;
				var activeDate = false;

				self.updateDebugValue('Scroll Position', offset);

				// Sort the lists by offset.
				var sortedLists = _.sortBy(self.$refs.lists, 'selfOffset');

				// Loop through each list and check to see if they
				// think they're active.
				_.each(sortedLists, function (raceList) {
					var newActiveDate = raceList.getActiveDate(offset);
					if (newActiveDate !== false) {
						activeList = raceList;
						activeDate = newActiveDate;
					}
				});

				// Set the data variables.
				self.currentDate = activeDate;
				self.currentHeaderText = activeList.title;
				self.currentHeaderClass = activeList.class;

				// Stuck header is only visible if we have an active list
				// and an active date.
				self.stuckHeaderVisible = activeList && activeDate;

			},
			addLists: function (lists) {

				var self = this;

				// If we're in all or month mode, just show the lists.
				if (this.mode == 'all') {
					_.each(lists, function (list) {
						self.listsLoading++;
						self.lists.push(list);
					});
					return;
				}

				// Otherwise, add some filter logic.
				var fields = {
					signature: 'signature',
					'triple-crown': 'triple_crown',
					'breeders-cup': 'breeders_cup'
				};
				(function (field) {
					_.each(deepClone([], lists), function (list) {
						list.filterPrepend = [];
						list.filterPrepend.push(function (result) {
							return _.filter(result, function (item) {
								return item[field];
							});
						});
						self.listsLoading++;
						self.lists.push(list);
					});
				})(fields[this.mode]);

			},
			loadAnotherMonth: function (firstMonth) {
				if (!this.supportAddingMonths) return;
				var newMonth = this.lastMonth.subtract(1, 'month').startOf('month');
				var newList = {};
				var self = this;
				(function (newMonth, firstMonth) {
					newList = {
						title: function () {
							return newMonth.startOf('month').format('MMMM YYYY');
						},
						arguments: function () {
							var le = moment(newMonth).endOf('month');
							if (le.unix() > moment().unix() && self.selectedMonth == 'none') {

								// Subtract 2 days to get rid of today and
								// yesterday, which are already displayed.
								le = moment().subtract(2, 'day').startOf('day');

							}
							var ge = moment(newMonth).startOf('month').subtract(4, 'hours'); // Subtract 4 hours to resolve issue where days on first of month weren't showing.
							return {
								parameters: {
									'field_date.ge': ge.format('YYYY-MM-DD hh:mm:ss'),
									'field_date.le': le.format('YYYY-MM-DD hh:mm:ss')
								},
								sort: 'field_date',
								direction: 'DESC',
								pagesize: 100
							}
						},
						fail(list) {

							if (firstMonth && self.selectedMonth === 'none') {
								console.log('First month empty, loading another one.');
								self.loadAnotherMonth();
							} else {
								self.monthFails++;
								if (self.monthFails > 2) {
									// If we fail to load a month more than 2 times, don't load any more months.
									self.supportAddingMonths = false;
								}
							}

						},
						emptyText: self.selectedMonth !== 'none'
					};
				})(newMonth, firstMonth);
				this.lastMonth = newMonth;
				this.addLists([newList]);
			},
			scrollBottom: function () {
				if (this.listsLoading > 0 || this.selectedMonth != 'none') return;
				this.loadAnotherMonth();
			},
			calculateSticky: function () {
				window.ABR.Sticky.calculate();
			},
			checkScroll: function () {
				if (jQuery(window).height() > jQuery(document).height() - 100) {
					this.scrollBottom();
				}
			},
			keypress: function (e) {
				var dayInRacing = $('.day-in-racing.visible');
				if (dayInRacing.length > 0) {
					var event;
					if (e.which === 39) event = new CustomEvent('next');
					else if (e.which === 37) event = new CustomEvent('previous');
					if (event) dayInRacing.get(0).dispatchEvent(event);
				}
			}
		},
		ready: function () {
			window.addEventListener('scroll', this.scroll);
			setInterval(this.checkScroll, 1000);
			this.checkScroll();
			window.addEventListener('keyup', this.keypress);
		},
		beforeDestroy: function () {
			window.removeEventListener('scroll', this.scroll);
		},
		watch: {
			mode: 'reloadAsyncData',
			selectedMonth: 'reloadAsyncData',
			stuckHeaderVisible: 'calculateSticky'
		}
	}
</script>



/** WEBPACK FOOTER **
 ** App.vue?ef20e0b2
 **/